import { openIdValidate, bindOpenId } from '@/service/http.js'
import { MessageBox } from 'mint-ui'
import { getQueryString, getLocalStorage ,setLocalStorage, removeLocalStorage} from '@/utils'
import { checkLogin } from '@/service/http'

export const validateMixin = {
	data () {
		return {

		}
	},
	created () {

	},
	methods: {
		validate (cb) {
			let userInfo = getLocalStorage(this.$store.state.userInfo)
			let userToken = getLocalStorage(this.$store.state.userToken)
			if (!userInfo || !userToken) {
				this.$router.push({name: '登录'})
			} else {
				cb && cb()
			}
        },
		hasLogin(cb){
			try {
				checkLogin().then(res => {
					if (res.data.code === 0) {
						if (res.data.data) {
							cb && cb()
						} else {
							this.$router.push({name: '登录'})
						}
					}
				}).catch(() => {
					this.$router.push({name: '登录'})
				})
			} catch(error){
				this.$router.push({name: '登录'})
			}
		},
	},
	destroyed () {
		MessageBox && MessageBox.close()
	}
}


// WEBPACK FOOTER //
// ./src/mixins/validate.js